import React from "react";

const Card = ({ children }) => {
  return (
    <div className="border-2 border rounded shadow-sm p-lg-4 p-1 my-4 card-book">
      {children}
    </div>
  );
};

export default Card;
